import '@/components/Cart.css';

import { CartHeader } from '@/components/CartHeader';
import { ProjectItemList } from '@/components/ProjectItemList';

export default function Cart() {
  return (
    <div className="pje-Cart" data-testid="cart">
      <CartHeader />
      <ProjectItemList />
    </div>
  );
}
